import { sectionStyles, sectionTitleStyles, sectionCardStyles } from '../viewFile.styleConstants';

export default theme => ({
    container: sectionStyles(theme),
    title: sectionTitleStyles(theme),
    description: sectionCardStyles(theme),
});